import { environment } from '../../../environments/environment';

let webpSupport = false;

// Teste de suporte de WebP
const img = new Image();
img.onload = function () {
  webpSupport = img.width > 0 && img.height > 0;
};
img.src =
  'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==';

export const getImageUrl = (id, width?, height?, lossless?) => {
  const retinaMultiplier = window.devicePixelRatio || 1;
  const realWidth = width ? Math.ceil(width * retinaMultiplier) : '';
  const realHeight = height ? Math.ceil(height * retinaMultiplier) : '';
  let environmentPrefix = '';
  if (environment.name !== 'prod') environmentPrefix = environment.name + '.';
  if (environment.name === 'local') environmentPrefix = 'feature.';
  const lossyExt = webpSupport ? 'webp' : 'jpg';
  const losslessExt = webpSupport ? 'webp_lossless' : 'png';
  const ext = lossless ? losslessExt : lossyExt;
  return `https://${environmentPrefix}images.iclinicpay.com.br/${realWidth}x${realHeight}/${id}.${ext}`;
};

/**
 * Id que o backend grava em users.photo_id quando o usuario nao enviou foto
 * (User::IMAGEM_DEFAULT_ID). A imagem por tras dele ainda e o logo antigo, entao
 * tratamos esse id como "sem foto" e caimos nas iniciais.
 */
export const DEFAULT_PROFILE_PHOTO_ID = 'OjnHqN_MSTKA0uCqPe1JK';

export const hasCustomProfilePhoto = (photoId: any): boolean =>
  !!photoId &&
  photoId !== 'null' &&
  photoId !== 'undefined' &&
  photoId !== DEFAULT_PROFILE_PHOTO_ID;

/**
 * URL da foto de perfil do usuario, ou null quando ele nao tem foto propria.
 */
export const getProfilePhotoUrl = (
  photoId: any,
  width?: number,
  height?: number
): string | null =>
  hasCustomProfilePhoto(photoId) ? getImageUrl(photoId, width, height) : null;

export default getImageUrl;
